import React from "react";
import BugsReports from "../Components/BugsReports/BugsReports";

const BugsReportPage = () => {
  return (
    <div>
      <BugsReports />
    </div>
  );
};

export default BugsReportPage;
